module.exports = __webpack_public_path__ + "img/prop-trading-banner-mobile.da68d892.png";